<script>
import _ from 'lodash';
import { loadStripe } from '@stripe/stripe-js';

import { authComputed, authMethods } from '@state/helpers';
import { breakpointsMixin } from '@mixins/breakpointsMixin';

export default {
  data() {
    return {
      cardHolderName: '',
      addressLine1: '',
      addressLine2: '',
      addressState: '',
      addressCity: '',
      addressCountry: '',
      cardHolderNameError: null,
      cardError: '',
      stripe: {},
      elements: {},
      card: {},
      cardExp: {},
      cardCvc: {},
      coupon: '',
      succesfulCoupon: null,
      checkingCoupon: false,
      couponResponse: '',
      submitting: false,
      validPrice: {},
      checkoutComplete: false,
      checkoutError: false,
      checkoutErrorMessage: '',
    };
  },
  components: {},
  mixins: [breakpointsMixin],
  mounted() {},
  beforeMount() {
    loadStripe(process.env.VUE_APP_STRIPE_KEY)
      .then((result) => {
        this.stripe = result;
        this.elements = result.elements();

        this.card = this.elements.create('cardNumber', {
          style: {
            base: {
              fontSize: '1.1em',
              letterSpacing: '0.761905px',
            },
          },
          placeholder: '0000 0000 0000 0000',
        });
        this.card.mount(this.$refs.card);

        this.cardExp = this.elements.create('cardExpiry', {
          style: {
            base: {
              fontSize: '1.1em',
              letterSpacing: '0.761905px',
            },
          },
          placeholder: 'MM/YY',
        });
        this.cardExp.mount(this.$refs.cardExp);

        this.cardCvc = this.elements.create('cardCvc', {
          style: {
            base: {
              fontSize: '1.1em',
              letterSpacing: '0.761905px',
            },
          },
          placeholder: '000',
        });
        this.cardCvc.mount(this.$refs.cardCvc);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  computed: {
    ...authComputed,
    userCurrentPricePlanId() {
      return this.currentUser.user &&
        this.currentUser.user.profile &&
        _.has(this.currentUser.user.profile, 'subscribed_plan') &&
        this.currentUser.user.profile.subscribed_plan
        ? this.currentUser.user.profile.subscribed_plan
        : this.currentUser.user &&
            this.currentUser.user.invitation &&
            _.has(this.currentUser.user.invitation, 'price_plan') &&
            this.currentUser.user.invitation.price_plan;
    },
    validPricingProduct() {
      const foundProduct = this.currentUser.trainerProducts.find((product) => {
        return product.plans.find((plan) => {
          return plan.id === this.userCurrentPricePlanId;
        });
      });

      return foundProduct;
    },
    validPricingPrice() {
      const foundProduct = this.currentUser.trainerProducts.find((product) => {
        return product.plans.find((plan) => {
          return plan.id === this.userCurrentPricePlanId;
        });
      });

      return foundProduct.plans.find((plan) => plan.id === this.userCurrentPricePlanId);
    },
    isRecurring() {
      return this.validPricingPrice && this.validPricingPrice.type === 'recurring';
    },
    validPricingInterval() {
      if (this.validPricingPrice.type === 'recurring') {
        if (this.validPricingPrice.recurring.interval === 'month') {
          return 'Monthly';
        } else if (this.validPricingPrice.recurring.interval === 'year') {
          return 'Annually';
        } else if (this.validPricingPrice.recurring.interval === 'week') {
          return 'Weekly';
        } else if (this.validPricingPrice.reucrring.interval === 'day') {
          return 'Daily';
        } else {
          return '';
        }
      }
      if (this.validPricingPrice.type === 'one_time') {
        return 'Once';
      } else {
        return '';
      }
    },
    intervalWeek() {
      if (this.validPricingPrice.type === 'recurring') {
        if (this.validPricingPrice.recurring.interval === 'month') {
          return this.validPricingPrice.recurring.interval_count * 4;
        } else if (this.validPricingPrice.recurring.interval === 'year') {
          return this.validPricingPrice.recurring.interval_count * 52.143;
        } else if (this.validPricingPrice.recurring.interval === 'week') {
          return this.validPricingPrice.recurring.interval_count;
        } else {
          return '';
        }
      }
      if (this.validPricingPrice.type === 'one_time') {
        return this.validPricingPrice && this.validPricingPrice.metadata && this.validPricingPrice.metadata.access_length;
      } else {
        return 'Once';
      }
    },
    totalPrice() {
      let totalPrice = 0;
      if (this.succesfulCoupon) {
        const amountOff = this.succesfulCoupon.amount_off
          ? this.succesfulCoupon.amount_off
          : (this.succesfulCoupon.percent_off * this.validPricingPrice.unit_amount) / 100;
        totalPrice = (this.validPricingPrice.unit_amount - amountOff) / 100;
      } else {
        totalPrice = this.validPricingPrice.unit_amount / 100;
      }
      return totalPrice;
    },
    isPMEO() {
      return process.env.VUE_APP_ORG_ID === '618183d65e84466f63c38878';
    },
  },
  methods: {
    ...authMethods,
    formValid() {
      if (this.cardHolderName && this.addressLine1 && this.addressState && this.addressCity && this.addressCountry) {
        return true;
      } else {
        if (!this.cardHolderName || this.cardHolderName === '') {
          this.cardHolderNameError = `Cardholder Name can't be blank`;
        } else {
          this.cardHolderNameError = 'Please fill all billing fields.';
        }

        return false;
      }
    },
    async checkCoupon() {
      this.checkingCoupon = true;
      this.couponResponse = '';
      const response = await this.lookupCoupon({ coupon: this.coupon });

      if (response.data.success) {
        this.succesfulCoupon = response.data.coupon;
      } else {
        this.couponResponse = response.data.message;
      }
      this.checkingCoupon = false;
    },
    checkoutSuccess() {
      this.$router.push({ name: 'home' });
    },
    handleSubmit() {
      this.checkoutError = false;
      this.cardError = '';
      this.cardHolderNameError = null;
      if (this.formValid()) {
        this.submitting = true;
        const data = {
          name: this.cardHolderName,
          address_line1: this.addressLine1,
          address_line2: this.addressLine2,
          address_state: this.addressState,
          address_city: this.addressCity,
          address_country: this.addressCountry,
        };

        this.stripe
          .createToken(this.card, data)
          .then((result) => {
            if (result.error) {
              this.cardError = result.error.message;
              this.submitting = false;
            } else {
              // Access the token with result.token
              this.checkout({
                price: this.currentUser.user.invitation.price_plan,
                stripeToken: result.token.id,
                coupon: this.succesfulCoupon ? this.succesfulCoupon.id : null,
              })
                .then((checkoutResponse) => {
                  if (checkoutResponse && checkoutResponse.success) {
                    this.submitting = false;
                    this.checkoutComplete = true;
                  } else {
                    this.checkoutError = true;
                    this.submitting = false;
                    this.checkoutErrorMessage = checkoutResponse.data.message;
                  }
                })
                .catch((err) => {
                  this.checkoutError = true;
                  this.submitting = false;
                  console.log(err);
                });
            }
          })
          .catch((err) => {
            this.checkoutError = true;
            this.submitting = false;
            console.log(err);
          });
      } else {
        this.submitting = false;
      }
    },
  },
};
</script>

<template>
  <form @submit.prevent="handleSubmit" :class="[{ isMobile: !$_isDesktopView() }]">
    <div class="checkout-container" v-if="!checkoutComplete">
      <b-row>
        <b-col class="header-container">
          <h1 v-if="$_isDesktopView()">Confirm and Pay</h1>
          <h1 class="mobile-header" v-if="!$_isDesktopView()">Checkout</h1>
        </b-col>
      </b-row>
      <div :class="['row card-sub-details']">
        <div class="col card card-form">
          <div class="form">
            <b-row>
              <b-col>
                <label>Name On Card</label>
                <BaseInputText
                  id="cardholder-name"
                  type="text"
                  classStyle="default"
                  placeholder="First Last Name"
                  label=""
                  v-model="cardHolderName"
                ></BaseInputText>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>Billing Address</label>
                <BaseInputText
                  id="billing-address"
                  type="text"
                  classStyle="default"
                  placeholder="Billing Address"
                  label=""
                  v-model="addressLine1"
                ></BaseInputText>
              </b-col>
              <b-col>
                <label>Billing Address 2</label>
                <BaseInputText
                  id="billing-address2"
                  type="text"
                  classStyle="default"
                  placeholder="Billing Address 2"
                  label=""
                  v-model="addressLine2"
                ></BaseInputText>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>City</label>
                <BaseInputText
                  id="billing-city"
                  type="text"
                  classStyle="default"
                  placeholder="City"
                  label=""
                  v-model="addressCity"
                ></BaseInputText>
              </b-col>
              <b-col>
                <label>State</label>
                <BaseInputText
                  id="billing-state"
                  type="text"
                  classStyle="default"
                  placeholder="State"
                  label=""
                  v-model="addressState"
                ></BaseInputText>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>Country</label>
                <BaseInputText
                  id="billing-country"
                  type="text"
                  classStyle="default"
                  placeholder="Country"
                  label=""
                  v-model="addressCountry"
                ></BaseInputText>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>Credit Card</label>
                <div class="stripe-input" ref="card" />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>Exp Date</label>
                <div class="stripe-input" ref="cardExp" />
              </b-col>
              <b-col>
                <label>CVC</label>
                <div class="stripe-input" ref="cardCvc" />
              </b-col>
            </b-row>
            <b-row class="apply-coupon-row">
              <b-col>
                <label>Coupon Code (Optional)</label>
                <BaseInputText
                  :class="[{ 'input-error': couponResponse }]"
                  id="coupon"
                  type="text"
                  classStyle="default"
                  placeholder="Coupon Code"
                  label=""
                  v-model="coupon"
                  :error="couponResponse ? couponResponse : null"
                ></BaseInputText>
              </b-col>
              <b-col class="apply-coupon" @click="checkCoupon">
                <BaseButton class="button btn-secondary small" type="button">
                  <span v-if="checkingCoupon === false">Apply</span>
                  <div v-else><b-spinner /></div>
                </BaseButton>
                <!-- <p class="errorMsg" v-if="couponResponse">{{ couponResponse }}</p> -->
              </b-col>
            </b-row>
            <p class="errorMsg" v-if="cardHolderNameError">{{ cardHolderNameError }}</p>
            <p class="errorMsg" v-if="cardError">{{ cardError }}</p>
          </div>
          <div v-if="!$_isDesktopView()" class="mobile-submit-btn">
            <b-row>
              <b-col class="p-4" cols="6" offset="6">
                <div id="sign-in">
                  <div class="submit-button">
                    <BaseButton class="button btn-primary large" :disabled="submitting || !validPricingPrice" type="submit">
                      <div v-if="submitting === false">Submit</div>
                      <div v-if="submitting"><b-spinner /></div>
                    </BaseButton>
                  </div>
                </div>
              </b-col>
            </b-row>
            <p class="error" v-show="!validPricingPrice">
              Invalid pricing plan applied to your account. Please contact your trainer for details.
            </p>
            <p class="error" v-show="checkoutError">
              Error processing your payment. Please try again. <br />
              {{ checkoutErrorMessage }}
            </p>
          </div>
        </div>
        <div class="col sub-details">
          <b-row>
            <b-col class="card price">
              <div class="row">
                <div class="col-1 check-col">
                  <div class="check">
                    <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-check'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M33 66c18.225 0 33-14.775 33-33S51.225 0 33 0 0 14.775 0 33s14.775 33 33 33z" fill="url(#paint0_linear)" fill-opacity=".6"/><path d="M17.368 33.55l4.466-5.321 8.645 7.255 15.748-18.116 5.243 4.56L35.803 39.95l-4.466 5.322L17.368 33.55z" fill="#fff"/><defs><linearGradient id="paint0_linear" x1="33" y1="0" x2="33" y2="66" gradientUnits="userSpaceOnUse"><stop stop-color="#55BCF5"/><stop offset="1" stop-color="#3E4FE2"/></linearGradient></defs></svg>
                  </div>
                </div>
                <div class="col">
                  <div class="row nick-name">
                    <p v-if="isRecurring">{{ validPricingPrice.nickname }} - {{ intervalWeek }}x/wk</p>
                    <p v-if="!isRecurring">{{ validPricingPrice.nickname }}</p>
                  </div>
                  <div class="row duration">
                    <p v-if="isRecurring">Billed {{ validPricingInterval }}</p>
                    <p v-if="!isRecurring">{{ intervalWeek === 1 ? intervalWeek + ' week' : intervalWeek + ' weeks' }}</p>
                  </div>
                </div>
                <div class="col-1">
                  <p>${{ validPricingPrice.unit_amount / 100 }}</p>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="final-price">
              <div class="row">
                <div class="col">
                  <div class="row plan-name">
                    <div class="col">
                      <p v-if="isRecurring"
                        >{{ validPricingPrice.nickname }} - {{ intervalWeek }}x/wk, {{ validPricingInterval }} Subscription:</p
                      >
                      <p v-if="!isRecurring">{{ validPricingPrice.nickname }}</p>
                    </div>
                    <div class="col-2">
                      <p>${{ validPricingPrice.unit_amount / 100 }}</p>
                    </div>
                  </div>
                  <div class="row discount" v-if="succesfulCoupon">
                    <div class="col">
                      <p>Discount:</p>
                    </div>
                    <div class="col-2">
                      <p>{{
                        succesfulCoupon.amount_off ? '-$' + succesfulCoupon.amount_off / 100 : '%' + succesfulCoupon.percent_off
                      }}</p>
                    </div>
                  </div>
                  <div class="row total">
                    <div class="col">
                      <p>Total Price:</p>
                    </div>
                    <div class="col-2">
                      <p>{{ '$' + totalPrice }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <div v-if="$_isDesktopView()">
            <b-row>
              <b-col class="p-4" cols="6" offset="6">
                <div id="sign-in">
                  <div class="submit-button">
                    <BaseButton class="button btn-primary large" :disabled="submitting || !validPricingPrice" type="submit">
                      <div v-if="!submitting">Submit</div>
                      <div v-else><b-spinner /></div>
                    </BaseButton>
                  </div>
                </div>
              </b-col>
            </b-row>
            <p class="error" v-show="!validPricingPrice">
              Invalid pricing plan applied to your account. Please contact your trainer for details.
            </p>
            <p class="error" v-show="checkoutError">
              Error processing your payment. Please try again.
            </p>
          </div>
        </div>
      </div>
    </div>
    <b-container
      :class="['success-container', { isMobile: !$_isDesktopView() }]"
      v-if="checkoutComplete && !submitting && !checkoutError"
    >
      <b-row class="success">
        <div class="col-4">
          <div>
            <div class="circle">
              <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="isPMEO" v-bind:class="'icon-check'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M33 66c18.225 0 33-14.775 33-33S51.225 0 33 0 0 14.775 0 33s14.775 33 33 33z" fill="url(#paint0_linear)" fill-opacity=".6"/><path d="M17.368 33.55l4.466-5.321 8.645 7.255 15.748-18.116 5.243 4.56L35.803 39.95l-4.466 5.322L17.368 33.55z" fill="#fff"/><defs><linearGradient id="paint0_linear" x1="33" y1="0" x2="33" y2="66" gradientUnits="userSpaceOnUse"><stop stop-color="#ff6e69"/><stop offset="1" stop-color="#ff6e69"/></linearGradient></defs></svg>
              <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg" v-else="" v-bind:class="'icon-check'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M33 66c18.225 0 33-14.775 33-33S51.225 0 33 0 0 14.775 0 33s14.775 33 33 33z" fill="url(#paint0_linear)" fill-opacity=".6"/><path d="M17.368 33.55l4.466-5.321 8.645 7.255 15.748-18.116 5.243 4.56L35.803 39.95l-4.466 5.322L17.368 33.55z" fill="#fff"/><defs><linearGradient id="paint0_linear" x1="33" y1="0" x2="33" y2="66" gradientUnits="userSpaceOnUse"><stop stop-color="#55BCF5"/><stop offset="1" stop-color="#3E4FE2"/></linearGradient></defs></svg>
            </div>
            <h2>You're all set!</h2>
            <p
              >Awesome, now on to the fun part! I am getting your new program set up and you’ll receive a notification when your
              plan has been uploaded to the app!</p
            ></div
          >
          <BaseButton class="button btn-secondary large" type="button">
            <div @click="checkoutSuccess">Continue</div>
          </BaseButton>
        </div>
      </b-row>
    </b-container>
  </form>
</template>

<style lang="scss" scoped>
@import '@design';
// @import url('https://fonts.googleapis.com/css?family=Proxima+Nova');
// @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@900&display=swap');
// stylelint-disable selector-pseudo-element-no-unknown
// stylelint-disable no-descending-specificity
// stylelint-disable selector-max-type
// stylelint-disable selector-id-pattern
form {
  height: calc(100%);
  margin-top: 40px;
  position: relative;
  &.isMobile {
    margin-top: unset;
    .checkout-container {
      padding-bottom: 10rem;
      .header-container {
        padding-left: unset;
        padding-right: unset;
        .mobile-header {
          color: #000;
          font-family: $base-font-family;
          font-size: 3.5rem;
          font-style: normal;
          font-weight: 800;
          letter-spacing: -0.761905px;
          line-height: 3rem;
          // margin-top: 20%;
        }
      }
      .mobile-submit-btn {
        justify-self: flex-end;
        .offset-6 {
          flex: 0 0 100%;
          margin-left: unset;
          max-width: 100%;
          width: 100%;
          #sign-in {
            width: 100%;
            .button {
              max-width: unset;
            }
          }
        }
      }
    }
    .card-sub-details {
      .sub-details {
        margin-left: unset;
        .price {
          padding: 2rem;
          padding-left: 2.7rem;
        }
        .final-price {
          padding: 2.3rem;
          padding-bottom: 1rem;
          .plan-name {
            p {
              color: #000;
              font-size: 1.6rem;
              line-height: 2.2rem;
            }
          }
          .discount {
            p {
              font-size: 16px;
              font-weight: 600;
              line-height: 50px;
            }
          }
          .total {
            padding-top: unset;
            p {
              color: #000;
              font-family: $base-font-family;
              font-size: 2.5rem;
              font-style: normal;
              font-weight: 550;
              line-height: 3.5rem;
            }
          }
        }
      }
      .card-form {
        border: unset;
        border-radius: unset;
        box-shadow: unset;
        margin-top: 3rem;
        padding: unset;
        label {
          text-transform: unset;
        }
        .apply-coupon-row {
          align-items: center;
          display: flex;
          flex-direction: row;
          justify-content: center;
          ::v-deep input {
            margin-bottom: 1.3rem;
          }
          .col {
            max-width: 50%;
          }
          .apply-coupon {
            padding-bottom: unset;
          }
        }
      }
    }
  }
}
.checkout-container {
  height: 100%;
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 0%;
  // padding-bottom: 10rem;
  position: relative;
  label {
    font-weight: 850;
    margin-bottom: 0.5rem;
    text-transform: uppercase;
  }
  .mobile-header {
    margin-top: 10%;
  }
  .card-sub-details {
    min-height: 90%;
    position: relative;
    @media screen and (max-width: 900px) {
      flex-direction: column-reverse;
    }
  }

  .apply-coupon {
    align-items: center;
    align-self: flex-start;
    display: flex;
    flex: 0 0 28.666667%;
    justify-content: center;
    margin-top: 2.5rem;
    max-width: 28.666667%;
    .button {
      align-items: center;
      display: flex;
      height: 4.5rem;
      justify-content: center;
      max-width: 20rem;
      width: 100%;
      span {
        align-items: center;
        font-style: normal;
        font-weight: 500;
        letter-spacing: 0.3px;
        line-height: 1rem;
        @include calc-font-size(1.3);
      }
    }
    .errorMsg {
      left: 13%;
      margin-bottom: unset;
      position: absolute;
      top: 75%;
    }
  }
  @media screen and (max-width: 916px) {
    .apply-coupon-row {
      display: flex;
      flex-direction: column;
      .apply-coupon {
        flex: 0 0 99.666667%;
        max-width: 99.666667%;
        padding-bottom: 3rem;
        .button {
          max-width: unset;
        }
        .errorMsg {
          left: 29%;
          position: absolute;
          top: 70%;
          white-space: nowrap;
        }
      }
    }
  }
}

h1 {
  font-family: $base-font-family;
  font-size: 42px;
  font-weight: 800;
  letter-spacing: -0.761905px;
  line-height: 78px;
  margin: auto;
  text-align: left;
}
.card {
  background: #fff;
  border: 1px solid rgba(151, 151, 151, 0.3);
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(214, 214, 214, 0.08);
  min-width: 27rem;
  padding: 3.5rem;

  @media screen and (max-width: 916px) {
    .button {
      width: 100%;
    }
  }

  .col {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
  }

  .StripeElement {
    background-color: rgba(237, 238, 243, 0.5);
    border: 1px solid $color-input-bg;
    border-radius: $base-border-radius;
    display: block;
    line-height: 10vh;
    margin-bottom: 2.5rem;
    max-height: 5rem;
    min-height: 1rem;
    padding: 0.8em 1.7em;
    transition: background $duration-animation-base, border $duration-animation-base;
    width: 100%;
  }

  .StripeElement--invalid {
    border-color: #fa755a;
  }

  .StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
  }

  ::v-deep input {
    font-family: 'Proxima Nova', sans-serif;
    font-size: 1.6em;
    font-style: normal;
    // font-weight: normal;
    line-height: 1.2rem;
    margin-bottom: 2.5rem;
    max-height: 4rem;
    min-height: 1rem;
    padding: 0.6em 1em;
    ::-webkit-input-placeholder {
      background: #393939;
      font-size: 2.8rem;
      font-weight: 900;

      /* Edge */
      height: 100%;
      line-height: 2.5rem;
      mix-blend-mode: normal;
      opacity: 0.2;
      @include calc-font-size(1.3);
    }
    :-ms-input-placeholder {
      background: #393939;
      font-size: 2.8rem;
      font-weight: 900;

      /* Internet Explorer 10-11 */
      height: 100%;
      line-height: 2.5rem;
      mix-blend-mode: normal;
      opacity: 0.2;
      @include calc-font-size(1.3);
    }
    ::placeholder {
      background: #393939;
      font-size: 2.8rem;
      font-weight: 900;
      height: 100%;
      line-height: 2.5rem;
      mix-blend-mode: normal;
      opacity: 0.2;
      @include calc-font-size(1.3);
    }
  }

  .check {
    align-items: center;
    background: #fff;
    border-radius: 50%;
    display: flex;
    height: 25px;
    justify-content: center;
    position: relative;
    width: 25px;
    z-index: 9999;
    svg {
      background: #4059e1;
      border-radius: 50%;
      height: 25px;
      width: 25px;
      path {
        &:first-child {
          fill: #4059e1;
        }
      }
    }
  }
}

.success-check {
  position: relative;
  .white-check {
    left: 0;
    position: absolute;
    top: 0;
  }
}

.sub-details {
  margin-left: 1.7rem;
  @media screen and (max-width: 674px) {
    margin-left: unset;
  }
  .final-price {
    background: #fff;
    border: 1px solid rgba(151, 151, 151, 0.3);
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(214, 214, 214, 0.08);
    margin-bottom: 1rem;
    padding: 3.5rem;
    padding-bottom: 2rem;
    padding-top: 3rem;
    .plan-name {
      .col {
        align-items: center;
        display: flex;
        text-align: start;
      }
      .col-2 {
        align-items: center;
        display: flex;
        flex: 0 0 12.666667%;
        max-width: fit-content;
        text-align: end;
      }
      p {
        color: #000;
        font-style: normal;
        font-weight: normal;
        line-height: 19px;
        @include calc-font-size(1.3);
      }
    }
    .discount {
      .col {
        align-items: center;
        display: flex;
        text-align: start;
      }
      .col-2 {
        align-items: center;
        display: flex;
        flex: 0 0 12.666667%;
        max-width: fit-content;
        text-align: end;
      }
      p {
        color: #4059e1;
        font-style: normal;
        font-weight: 600;
        line-height: 19px;
        text-align: end;
        @include calc-font-size(1.3);
      }
    }
    .total {
      padding-top: 2rem;
      .col {
        align-items: center;
        display: flex;
        text-align: start;
      }
      .col-2 {
        align-items: center;
        display: flex;
        flex: 0 0 12.666667%;
        max-width: fit-content;
        text-align: end;
      }
      p {
        color: #000;
        font-family: $base-font-family;
        font-style: normal;
        font-weight: bold;
        line-height: 42px;
        @include calc-font-size(1.9);
      }
    }
  }
}

.price {
  margin-bottom: 1.7rem;
  padding-bottom: 3rem;
  padding-top: 3rem;

  .col-2 {
    align-items: center;
    display: flex;
    flex: 0 0 12.666667%;
    justify-content: flex-end;
    max-width: 12.666667%;
  }
  p {
    font-size: 1.5rem;
    font-weight: 900;
    margin-bottom: unset;
  }
  .duration {
    p {
      align-items: center;
      color: #000;
      font-size: 16px;
      font-style: normal;
      font-weight: normal;
      line-height: 19px;
    }
  }
  .nick-name {
    p {
      align-items: center;
      color: #000;
      font-size: 19px;
      font-style: normal;
      font-weight: bold;
      line-height: 26px;
      text-align: start;
    }
  }
  .col-1 {
    align-items: center;
    display: flex;
    flex: 0 0 10.333333%;
    flex-direction: column;
    justify-content: center;
    max-width: fit-content;
    &.check-col {
      flex: 0 0 5.333333%;
      margin-right: 1rem;
      max-width: 5.333333%;
    }
    p {
      align-items: center;
      color: rgba(0, 0, 0, 0.85);
      display: flex;
      font-size: 25px;
      font-style: normal;
      font-weight: 600;
      line-height: 30px;
      text-align: center;
    }
  }
}

#sign-in {
  .submit-button {
    align-items: center;
    display: flex;
    justify-content: flex-end;
    .button {
      align-items: center;
      display: flex;
      height: 5rem;
      justify-content: center;
      max-width: 30rem;
      width: 60%;
    }
    @media screen and (max-width: 916px) {
      .button {
        width: 100%;
      }
    }
  }
}

.error {
  color: red;
}

.errorMsg {
  color: red;
  //  @media screen and (max-width: 916px) {
  //    position: absolute;
  //    bottom: 0;
  //  }
}

.success {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 6%;
  .col-4 {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media screen and (max-width: 1100px) {
      flex: 0 0 53.333333%;
      max-width: 53.333333%;
    }
    div {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      @media screen and (max-width: 1100px) {
        flex: 0 0 53.333333%;
        max-width: 53.333333%;
      }
    }
    h2 {
      color: #000;
      font-family: $base-font-family;
      font-size: 35px;
      font-style: normal;
      font-weight: bold;
      letter-spacing: -0.761905px;
      line-height: 52px;
      text-align: center;
      white-space: nowrap;
    }
    p {
      color: #000;
      font-size: 16px;
      font-style: normal;
      font-weight: normal;
      line-height: 23px;
      text-align: center;
    }

    .success-check {
      align-items: center;
      background: #fff;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      margin-bottom: 1rem;
      position: relative;
      width: fit-content;
      z-index: 9999;
      svg {
        // width: 25px;
        // height: 25px;
        background: linear-gradient(180deg, #55bcf5 0%, #3e4fe2 100%);
        border-radius: 50%;
        path {
          &:first-child {
            fill: linear-gradient(180deg, #55bcf5 0%, #3e4fe2 100%);
          }
        }
      }
    }
  }
  .btn-secondary {
    align-items: center;
    display: flex;
    justify-content: center;
    margin-top: 4rem;
    width: 90%;
  }
}

.success-container {
  &.isMobile {
    height: 60vh;
    .success {
      height: 100%;
      .col-4 {
        align-items: center;
        display: flex;
        flex: 0 0 99.333333%;
        flex-direction: column;
        height: 100%;
        justify-content: space-between;
        max-width: 99.333333%;
        h2 {
          justify-self: center;
          margin-left: 5%;
          margin-right: 5%;
        }
        p {
          justify-self: center;
          margin-left: 5%;
          margin-right: 5%;
        }
      }
      .btn-secondary {
        //  align-self: flex-end;
        justify-self: flex-end;
        width: 95%;
      }
    }
  }
}
</style>
